import { VBottomSheet } from 'vuetify/components/VBottomSheet'
import { VDialog } from 'vuetify/components/VDialog'
import { useBreakpoints } from '@/composition/useBreakpoints'

export function useBottomSheetComponent() {
  const { breakpoints } = useBreakpoints()

  const dialogComponent = computed(() => (breakpoints.xsAndUp ? VDialog : VBottomSheet))

  return {
    dialogComponent,
  }
}
